import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsCombosCreateConfigureView } from './configure/configure';
import { ProgramsCombosCreateControllerModule } from './controllers/ProgramsCombosCreateController';
import { ProgramsCombosCreateDescriptionView } from './description/description';
import { ProgramsCombosCreateScheduleView } from './schedule/schedule';

export const ProgramsCombosCreateView = angular
  .module('acme.view.application.programs.combos.create', [
    uiRouter,
    'ui.bootstrap',
    ProgramsCombosCreateControllerModule,
    ProgramsCombosCreateDescriptionView,
    ProgramsCombosCreateScheduleView,
    ProgramsCombosCreateConfigureView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programs.combos.create',
      url: '/create',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'ProgramsCombosCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/combos/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '   ',
        permissions: ['COMBO_TEMPLATE_CREATE'],
      },
    });

    $stateProvider.state({
      name: 'application.programs.combos.edit',
      url: '/edit/:comboId',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'ProgramsCombosCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/combos/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '   ',
        permissions: ['COMBO_TEMPLATE_UPDATE'],
      },
    });
  }).name;
